/**
 * ReviewResultsPage — full-screen moderator review of round results.
 *
 * Route: /sim/:id/review-results (opens in new tab from pending action)
 * Shows all countries with editable analytical values + deltas.
 * Approve → results published, round advances, tab can close.
 *
 * SPEC: MODULES/M4_SIM_RUNNER/SPEC_REVIEW_ROUND_RESULTS.md
 */

import { useParams, useNavigate } from 'react-router-dom'
import { ReviewRoundResults } from '@/components/facilitator/ReviewRoundResults'

export function ReviewResultsPage() {
  const { id: simId } = useParams<{ id: string }>()
  const navigate = useNavigate()

  if (!simId) return null

  return (
    <div className="min-h-screen bg-base p-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-4 mb-4">
          <button onClick={() => navigate(-1)}
            className="font-body text-caption text-text-secondary hover:text-text-primary">
            &larr; Back to Dashboard
          </button>
        </div>
        <ReviewRoundResults simId={simId} />
      </div>
    </div>
  )
}
